<template>
    <article class="wikiViewerWrap" ref="wikiWrap">
        <WikiIndex v-if="wikiIndex" :indexList=titleIndex :scrollMode=true @itemSelect="checkTitlePosition"
                   @mounted="data=>bookmarkInfo=data"></WikiIndex>
        <div ref="scrollWrap" class="contentsWrap" @scroll="moveScroll">
            <section class="wikiContents" data-depth="0">
                <WikiProcessReadOnly
                        v-if="isProcess.isProcess"
                        :item = "Data"
                >
                </WikiProcessReadOnly>
            </section>
            <section class="wikiContents" data-depth="0">
                <WikiKeywordReadOnly v-if="isKeyword.isKeyword"
                         :item="isKeyword"
                         :readonly="true"
                ></WikiKeywordReadOnly>
            </section>
            <WikiContent v-for="data in nodeData" :editor="data"></WikiContent>
        </div>
        <Loading :visible="loading"/>
    </article>
</template>
<script>
    // 좌측 title component
    import WikiIndex from '@components/protocolEditor/wikiIndex';
    // 공정도 사진 component
    import WikiProcessReadOnly from '@components/protocolEditor/WikiProcessReadOnly';
    // 용어설명 component
    import WikiKeywordReadOnly from '@components/protocolEditor/WikiKeywordReadOnly';
    // 하위 모든 데이터를 뿌려주는 component
    import WikiContent from '@components/platform_new/wikiViewerContents';
    // wiki 형식에 맞게 파싱해 주는 함수
    import {typeOfJson} from "@processEditor/CommNew";
    // wiki를 만들어 주는 js 파일
    import MakeNodesInfomation from '@components/platform_new/wikiApi.js';
    import Loading from '@common/loading';

    let makeNodes = new MakeNodesInfomation();
    export default {
        name: 'wikiContent',
        props: {
            Data: {
                type: Object, default: function () {
                    return {}
                }
            },
            wikiIndex: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                protocolType: null,
                isProcess: false,
                isKeyword: false,
                titleIndex: [],
                nodeData: [],
                titleRefs: [],
                bookmarkInfo: null,
                scrollTimer: null,
                scrollTopPoint: 0,
                loading: false,
                awaitContentStatus: {
                    'process': false,
                    'keyword': false,
                    'content': false
                }
            }
        },
        components: {WikiProcessReadOnly, WikiKeywordReadOnly, WikiContent, WikiIndex, Loading},
        computed: {},
        watch: {
            async Data(info) {
                await this.loadProtocol();
                this.titleRefs = this.$refs.wikiWrap.querySelectorAll('[data-depth="0"] .title');
                this.scrollTopPoint = this.titleRefs[0].getBoundingClientRect();
            }
        },
        async mounted() {
            if (this.Data?.protocolId || this.$route.query.protocolId) {
                makeNodes = new MakeNodesInfomation();
                await this.loadProtocol();
                this.titleRefs = this.$refs.wikiWrap.querySelectorAll('[data-depth="0"] .title');
                this.scrollTopPoint = this.titleRefs[0].getBoundingClientRect();
            }
        },
        methods: {
            async loadProtocol() {
                this.loading = true;
                let param = {
                    protocolId: this.$route.query.protocolId,
                    taKey: this.Data.TAKey || this.$route.query.TAKey,
                };
                
                let response = null;
                if (param.taKey) {
                    param.taKey = param.taKey.replaceAll(' ', '+');
                }
                response = await this.$wApi.protocol.release.detail(param);
                let issue;
                this.protocolType = response.protocolType;
                makeNodes.setNodeContents = typeOfJson(response.nodeContent);
                const nodeContent = typeOfJson(response.nodeContent);
                this.nodeData = [];
                if (this.Data.json) {
                    // object deep copy를 위해 문자열로 변환 후 재수정
                    issue = JSON.parse(typeof this.Data.json.issues == 'string' ? this.Data.json.issues : JSON.stringify(this.Data.json.issues));
                    issue.map((item) => {
                        if (item.category === 'SHORTVALUE') item.display = false;
                    });
                } else {
                    issue = typeOfJson(response.content).issues;
                }
                let nodeDatas = makeNodes.makeNodeList(JSON.parse(JSON.stringify(issue)));

                this.titleIndex = [];

                nodeDatas[0].child.map((item) => {
                    if(this.Data.beforeProcessId != null){
                        if (item.hasOwnProperty('isProcess')) {
                            this.isProcess = item
                            this.titleIndex.push(item);
                        }    
                    }
                    if (item.hasOwnProperty('isKeyword')) {
                        this.isKeyword = item
                        this.titleIndex.push(item);
                    }
                })
                
                if(nodeContent && this.isKeyword != false){
                    this.isKeyword.content = nodeContent[this.isKeyword.key];
                }

                this.nodeData = await makeNodes.makeListData(nodeDatas[0].child);

                for (let item of this.nodeData) {
                    if (item.step <= 0) {
                        this.titleIndex.push(item);
                    }
                }
                this.loading = false;
            },

            checkTitlePosition(info) {
                if (!info || !this.titleRefs.length === 0) return
                const targetElement = this.titleRefs[info.index];
                if (targetElement) {
                    const offset = targetElement.offsetTop;
                    const containerElement = this.$refs.scrollWrap;
                    const marginTop = 5;
                    const start = containerElement.scrollTop;
                    const end = offset - containerElement.offsetTop - marginTop;
                    let change = 0;
                    let position = start;
                    let intervalEndTime = 150;
                    let intervalTime = 5;
                    // 소수점이 발생하면 오차가 생기기 때문에 intervalEndTime의 약수를 intervalTime로 지정.
                    const division = intervalEndTime / intervalTime;
                    try {
                        if (start < end) {
                            change = end - start;
                            const changeScroll = setInterval(function () {
                                containerElement.scrollTop = position = position + change / division;
                            }, intervalTime);
                            setTimeout(function () {
                                clearTimeout(changeScroll);
                            }, intervalEndTime);
                        } else if (start > end) {
                            change = start - end;
                            const changeScroll = setInterval(function () {
                                containerElement.scrollTop = position = position - change / division;
                            }, intervalTime);
                            setTimeout(function () {
                                clearTimeout(changeScroll);
                            }, intervalEndTime);
                        } else {
                            return;
                        }
                    } catch (e) {
                        containerElement.scrollTop = end;
                        clearTimeout();
                    }
                }
            },
            moveScroll(e) {
                if (!this.wikiIndex || this.wikiIndex.lenght == 0) return;
                clearTimeout(this.scrollTimer);
                let before = null;
                const checkPosition = (refPos) => {
                    let index = 0, height = 0;
                    for (let item of this.titleRefs) {
                        let rect = item.getBoundingClientRect();
                        if (before) {
                            refPos = refPos - height;
                            height = rect.top - before.rect.top;
                            if (height - (height / 3) > refPos) {
                                this.bookmarkInfo.handler.select(index - 1);
                                break;
                            }
                        }
                        before = {item, rect};
                        index++;
                    }
                }
                this.scrollTimer = setTimeout(() => {
                    checkPosition(this.$refs.scrollWrap.scrollTop)
                }, 100);
            }
        },
    }

</script>
<style lang="scss" scoped>
    .wikiViewerWrap {
        display: flex;
        min-width: 1200px;
        height: 100%;
        width: 100%;

        .contentsWrap {
            width: 100%;
            height: 700px;
            padding: 40px;
            overflow: auto;
            @include scrlbar;
        }

        .wikiContents {
            .title {
                position: relative;
                top: 0;
                left: 0;
                padding: 12px;
                font-size: 20px;
                font-weight: 600
            }

            ol, ul {
                padding-left: 18px;

                li {
                    list-style: initial;
                }
            }

            li {
                list-style: initial;
            }
        }

        .contentStep1 .title {
            padding: 12px;
            font-size: 20px;
            font-weight: 600;
        }

        .keywords {
            table td {
                vertical-align: middle;
            }
        }
    }
</style>